export default {"src":"/_next/static/media/ISO-footer.69106ddb.svg","height":38,"width":47,"blurWidth":0,"blurHeight":0};